module.exports = __webpack_public_path__ + "static/media/ginger.d4c72a7f.jpg";